"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'name',
    'sandbox',
    'src',
    'srcdoc',
    'width',
    'height',
    'allowFullScreen',
]);
//# sourceMappingURL=iframe.js.map